<template>
  <div class="duration-wrapper">
    <div class="checkbox-row">
      <v-checkbox
        v-model="checked"
        label="Fixe Anzahl"
        color="#33bbff"
        value="1"
        :disabled="checked == '1'"
        @change="$emit('input', fix)"
        hide-details
        :readonly="readonly"
      ></v-checkbox>

      <v-checkbox
        v-model="checked"
        label="Anzahl (von - bis)"
        thumb-color="#33bbff"
        color="#33bbff"
        track-color="white"
        track-fill-color="#33BBFF75"
        value="2"
        :disabled="checked == '2'"
        @change="$emit('input', range)"
        hide-details
        :readonly="readonly"
      ></v-checkbox>

      <v-checkbox
        v-model="checked"
        label="Nicht anwendbar"
        color="#33bbff"
        value="0"
        :disabled="checked == '0'"
        @change="$emit('input', null)"
        hide-details
        :readonly="readonly"
      ></v-checkbox>
    </div>

    <div v-if="checked == 0"></div>
    <div class="slider-wrapper" v-if="checked == 1">
      <v-slider
        :readonly="readonly"
        @input="onChangeSingle($event)"
        max="20"
        min="0"
        :value="value"
        thumb-color="#33bbff"
        color="#33bbff"
        track-color="white"
        track-fill-color="#33BBFF75"
      ></v-slider>
      <div class="input-values">
        <div class="number-input-w-text">
          <input
            :readonly="readonly"
            class="number-input"
            :value="value"
            v-on:blur="changeFix($event, 0)"
          />
          <p class="minutes big-label">Pers.</p>
        </div>
      </div>
    </div>
    <div class="slider-wrapper" v-if="checked == 2">
      <v-range-slider
        :readonly="readonly"
        @input="onChangeRange($event)"
        max="20"
        min="0"
        thumb-color="#33bbff"
        color="#33bbff"
        track-color="white"
        track-fill-color="#33BBFF75"
        :value="value"
      ></v-range-slider>
      <div class="input-values">
        <div class="">
          <input
            class="number-input"
            :readonly="readonly"
            :value="value[0]"
            v-on:blur="changeRange($event, 0)"
          />
        </div>
        <div class="number-input-w-text">
          <input
            class="number-input"
            :readonly="readonly"
            :value="value[1]"
            v-on:blur="changeRange($event, 1)"
          />
          <p class="minutes big-label">Pers.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "readonly"],
  data() {
    return {
      checked: "0",
      range: [10, 15],
      fix: 10,
    };
  },
  methods: {
    changeFix(e) {
      this.fix = parseInt(e.srcElement.value);
      this.$emit("input", this.fix);
    },
    changeRange(e, i) {
      let tmpRange;
      if (i === 0) {
        tmpRange = [parseInt(e.srcElement.value), this.range[1]];
      } else {
        tmpRange = [this.range[0], parseInt(e.srcElement.value)];
      }
      this.range = tmpRange;

      this.$emit("input", tmpRange);
    },
    checkIfActive(e, value) {
      if (this.checked == null) {
        e.preventDefault();
      }
    },
    onChangeSingle(value) {
      this.fix = value;
      this.$emit("input", value);
    },
    onChangeRange(values) {
      console.log(values);
      this.range = values;
      this.$emit("input", values);
    },
  },
  mounted() {
    if (typeof this.value == "number") {
      this.checked = "1";
    } else if (Array.isArray(this.value)) {
      this.checked = "2";
    } else if (this.value == null) {
      this.checked = "0";
    }
  },
  computed: {},
};
</script>

<style>
</style>
